import { AxiosResponse } from 'axios';
import { buildPath } from '../lib/url';
import { backendClient as client } from './clients';
import { AdamsAccessDTO } from './dto';
import { GetManyUnpaged } from './types';

export const ADAMS_ACCESS_PATH = 'adams-access';

export const getAdamsAccessData: GetManyUnpaged<
    { accessPointNames: string[]; egroupIds: (number | null | undefined)[]; personIds: (number | undefined)[] },
    AdamsAccessDTO
> = async ({ accessPointNames, egroupIds, personIds, config }) =>
    client
        .get(buildPath([ADAMS_ACCESS_PATH]), {
            ...config,
            params: {
                accessPointNames: accessPointNames.join(','),
                egroupIds: egroupIds.join(','),
                personIds: personIds.join(','),
            },
        })
        .then((response: AxiosResponse) => response.data);
